module.exports = __webpack_public_path__ + "static/media/dashboard-icon.328e58c7.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/dashboard-icon.svg
// module id = 1028
// module chunks = 0